import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { SectionLabel, Reveal } from "./Reveal";

export const Steps = () => {
  const { t } = useLang();
  return (
    <section className="relative py-24 md:py-32 border-t border-white/10" data-testid="steps-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <SectionLabel n="04">{t.steps.label}</SectionLabel>
        <Reveal>
          <h2 className="font-display text-3xl md:text-5xl mt-8 text-[var(--text)] max-w-3xl">{t.steps.title}</h2>
        </Reveal>
        <div className="relative mt-16">
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
            className="hidden md:block absolute top-[34px] left-0 right-0 h-px bg-[var(--gold)] origin-left"
          />
          <div className="grid md:grid-cols-4 gap-10 md:gap-8">
            {t.steps.items.map((s, i) => (
              <Reveal key={i} delay={0.15 * i} className="relative" >
                <div className="flex md:block items-start gap-5" data-testid={`step-${i}`}>
                  <div className="relative z-10 shrink-0 w-[68px] h-[68px] rounded-full bg-[var(--bg)] border border-[var(--gold)] grid place-items-center font-display text-xl text-[var(--gold)]">
                    0{i + 1}
                  </div>
                  <div className="md:mt-8">
                    <h3 className="font-display text-lg md:text-xl text-[var(--text)]">{s.t}</h3>
                    <p className="mt-2 text-sm text-[var(--muted)] leading-relaxed">{s.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
